import { arrayOf, shape, number, string, bool } from 'prop-types';
import styled from 'styled-components';
import StepperItem from './stepperItem';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 32px;

  @media screen and (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

function Stepper({ className, currentStep, isComplete, items }) {
  return (
    <Wrapper className={className}>
      {items.map(({ stepNumber, label }) => (
        <StepperItem
          key={stepNumber}
          stepNumber={stepNumber}
          isActive={stepNumber <= currentStep || isComplete}
          isLastStep={items.length === stepNumber}
          label={label}
        />
      ))}
    </Wrapper>
  );
}

Stepper.propTypes = {
  className: string,
  currentStep: number.isRequired,
  isComplete: bool,
  items: arrayOf(shape({
    className: string,
    stepNumber: number.isRequired,
    label: string.isRequired,
  })).isRequired,
};

Stepper.defaultProps = {
  className: '',
  isComplete: false,
}

export default Stepper;